import {
  BarChart3Icon,
  BoxesIcon,
  CreditCardIcon,
  LandmarkIcon,
  ReceiptIcon,
  ShoppingCartIcon,
  UsersIcon,
} from 'lucide-react'
import type { IndustryCard, RelatedProduct } from '../../types/product'

export const productCatalog: Record<string, RelatedProduct> = {
  'sales-pos': {
    icon: CreditCardIcon,
    title: 'Point of Sale',
    copy: 'Record sales, accept every payment method, and issue EBM receipts.',
    href: '/products/sales-pos',
  },
  inventory: {
    icon: BoxesIcon,
    title: 'Inventory',
    copy: 'Stock levels update with every sale, so you know when to reorder.',
    href: '/products/inventory',
  },
  purchases: {
    icon: ShoppingCartIcon,
    title: 'Purchases',
    copy: 'Order from suppliers and restock at the right time and price.',
    href: '/products/purchases',
  },
  expenses: {
    icon: ReceiptIcon,
    title: 'Expenses',
    copy: 'Record every cost and see exactly where your money goes.',
    href: '/products/expenses',
  },
  customers: {
    icon: UsersIcon,
    title: 'Customers',
    copy: 'Keep purchase history, balances, and credit for every regular.',
    href: '/products/customers',
  },
  reports: {
    icon: BarChart3Icon,
    title: 'Reports & Insights',
    copy: 'Turn daily activity into clear profit and cash flow reports.',
    href: '/products/reports',
  },
  'business-finance': {
    icon: LandmarkIcon,
    title: 'Business Financing',
    copy: 'Use your records to check eligibility for working capital.',
    href: '/products/business-finance',
  },
}

export const industryCatalog: Record<string, IndustryCard> = {
  retail: {
    title: 'Retail',
    copy: 'Sell faster and keep stock under control.',
    image: 'https://cdn.magicpatterns.com/uploads/hrSxrDybaWkqRaXzBR7V3y/ChatGPT_Image_Sep_26,_2026,_04_09_02_PM-1.png',
    alt: 'Shopkeeper arranging products on shelves in a busy retail store',
    href: '/solutions/retail',
  },
  food: {
    title: 'Food & Beverage',
    copy: 'Manage orders, ingredients, and daily sales.',
    image: 'https://cdn.magicpatterns.com/uploads/um4PVUwRMuB6Dq6iSx7Up4/ChatGPT_Image_Sep_26,_2026,_04_09_05_PM-4.png',
    alt: 'Chef plating food beside an order screen in a restaurant kitchen',
    href: '/solutions/food-beverage',
  },
  manufacturing: {
    title: 'Manufacturing',
    copy: 'Track materials, production, and finished goods.',
    image: 'https://cdn.magicpatterns.com/uploads/c8Nf8XJGRxSAWm6B5i5fj7/ChatGPT_Image_Sep_26,_2026,_04_09_09_PM-1.png',
    alt: 'Worker inspecting finished goods in a small manufacturing workshop',
    href: '/solutions/manufacturing',
  },
  services: {
    title: 'Services',
    copy: 'Manage clients, jobs, and payments in one place.',
    image: 'https://cdn.magicpatterns.com/uploads/6bTCAA9T5mAFwtdRuNtBvU/ChatGPT_Image_Sep_26,_2026,_04_09_11_PM-2.png',
    alt: 'Service professional meeting a client across a desk in a small office',
    href: '/solutions/services',
  },
  hotels: {
    title: 'Hospitality',
    copy: 'Track bookings, guests, and property income.',
    image: 'https://cdn.magicpatterns.com/uploads/kif38iqadZcEesbQLKpsTR/ChatGPT_Image_Sep_26,_2026,_04_09_03_PM-2.png',
    alt: 'Receptionist welcoming a guest at a boutique hotel front desk',
    href: '/solutions/hospitality',
  },
  healthcare: {
    title: 'Healthcare',
    copy: 'Manage pharmacy sales, clinic services, and stock.',
    image: 'https://cdn.magicpatterns.com/uploads/iDUc4UaB1F5bDm8tDia9dE/ChatGPT_Image_Sep_26,_2026,_04_09_04_PM-3.png',
    alt: 'Pharmacist serving a customer at a neighborhood pharmacy counter',
    href: '/solutions/healthcare',
  },
}
